<script>
import Vue              from 'vue';
import { Doughnut }     from 'vue-chartjs'

export default {
    extends: Doughnut,
    props: {
        chart: {
            type: Object,
            default: null
        },
        settings: {} 
    },
    data() {
        return {
            data: {},
            chartType: '',
            chartData: { borderAlign: 'center' },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { position: 'right' },
            }
        }
    },
    created() {
        Vue.$log.info('※ DoughnutChart.vue created data =>', this.chart);
        if(this.chart !== null) {
            this.chartType = this.chart.chartType;
            this.data = this.chart.chartData[0];
        };

        if(['ICO', 'MRCO'].includes(this.chartType)) {
            Object.assign(this.chartData, {
                labels : ['Unread', 'Read'],
                datasets: [{
                    data: [ this.data.NOT_YET, this.data.READ ],
                    backgroundColor: ['#364fc7', '#60c0dc', ],
                            // ? ['#3B54C7', '#E0E8F1']
                            // : ['#4AC7EC', '#E0E8F1']
                }]
            });

            Object.assign(this.options, {
                title: { display: true, position: 'bottom', text: this.data.KNOWLEDGE_TITLE },
            });

        // Chart type 'QA'
        } else {
            Object.assign(this.chartData, {
                labels : ['Open', 'Close', ],
                datasets: [{
                    data: [ this.data.OPEN, this.data.CLOSE, ],
                    backgroundColor: ['#364fc7', '#60c0dc', ],
                }]
            });
            Object.assign(this.options, {
                title: {
                    display: true,
                    position: 'bottom',
                    text: this.settings.TITLE,
                },
            });
        };
    },
    mounted () {
        this.renderChart(this.chartData, this.options);
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/charts/DoughnutChart.vue